// src/Presentation/Components/Products/ProductSpecifications.tsx
import React from "react";
import styles from "./Product.module.css";
import { IProductSpecificationsProps } from "@model/Products.model";

const ProductSpecifications: React.FC<IProductSpecificationsProps> = ({ specs }) => {
  if (!specs?.length) return null;

  return (
    <section className={styles.productSpecsSP} data-testid="product-specs">
      <h2 className={styles.sectionTitleSP} data-testid="product-specs-title">
        Specifications
      </h2>

      <table className={styles.specsTableSP} data-testid="specs-table">
        <tbody data-testid="specs-tbody">
          {specs.map((s, i) => (
            <tr key={`${s.label}-${i}`} data-testid={`spec-row-${i}`}>
              <th
                scope="row"
                className={styles.specLabelCellSP}
                data-testid={`spec-label-${i}`}
              >
                {s.label}
              </th>
              <td className={styles.specValueCellSP} data-testid={`spec-value-${i}`}>
                {s.value}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
};

export default ProductSpecifications;
